import React from "react";
import classes from "./Home.module.css";
import SingleElement from "./SingleElement/SingleElement";

import resume from "../../assets/imgs/resume.jpg";
import reactCertificate from "../../assets/imgs/reactCertificate.jpg";
import npssurvey from "../../assets/imgs/nps-survey.jpg";
import iodesign from "../../assets/imgs/iodesign.jpg";
import bloggerIO from "../../assets/imgs/bloggerIO.jpg";
import hangman from "../../assets/imgs/hangman.jpg";
import nonfig from "../../assets/imgs/nonfig.jpg";
import goaplha from "../../assets/imgs/goaplha.jpg";
import shopify from "../../assets/imgs/shopify.jpg";
import burger from "../../assets/imgs/burger.jpg";
import deven from "../../assets/imgs/deven.jpg";
import myplaces from "../../assets/imgs/myplaces.jpg";
import theseventales from "../../assets/imgs/theseventales.jpg";
import worldscitech from "../../assets/imgs/worldscitech.jpg";
import fastcashhomes from "../../assets/imgs/fastcashhomes.jpg";
import theregaltraders from "../../assets/imgs/theregaltraders.jpg";
import nagconcept from "../../assets/imgs/nagconcept.jpg";
import snaxa from "../../assets/imgs/snaxa.jpg";
import marlesdigitalagency from "../../assets/imgs/marlesdigitalagency.jpg";
import thetechcreators from "../../assets/imgs/thetechcreators.jpg";
import snaxaApp from "../../assets/imgs/snaxaApp.jpg";
import riziptApp from "../../assets/imgs/riziptApp.jpg";

import { NavLink } from "react-router-dom";

const Home = (props) => {
	return (
		<React.Fragment>
			<div className={classes.TopIntro}>
				<h3>Hi, I'm Muzammil</h3>
				<span>DESIGNER + DEVELOPER</span>
				<div
					style={{
						width: "50px",
						height: "2px",
						background: "#0f6fc6c4",
						margin: "10px 0",
					}}></div>
				<p>
					I am a Computer Science Graduate, Freelancer, Designer, Developer, a
					JavaScript enthusiast.
				</p>
			</div>
			<div className={classes.Help}>
				<h2>I can help.</h2>
				<h4>I'm currently available for freelance work!</h4>
				<p>
					If you have a project that you want to get started, think you need my
					help with something or just fancy saying hey, then get in touch.
				</p>
				<NavLink to='/contact'>Message Me!</NavLink>
			</div>
			<br></br>
			<br></br>
			<br></br>
			<div className={classes.Home}>
				<div className={classes.Row}>
					<SingleElement
						className={classes.Column}
						img={resume}
						alt='Sheikh Muzammil Ahmed - Resume'
						title='My Resume'
						to='/resume'
					/>
					<SingleElement
						className={classes.Column}
						img={reactCertificate}
						alt='Sheikh Muzammil Ahmed - React Certificate'
						title='My Certifications'
						to='/certificates'
					/>
				</div>

				<div className={classes.SectionHeading}>
					<h4>
						<span>SOME OF MY WORK</span>
					</h4>
				</div>

				<div className={classes.Row}>
					<SingleElement
						img={snaxaApp}
						className={classes.Column}
						alt='Snaxa'
						title='Snaxa (React Native App)'
						target='_blank'
						// to='https://expo.io/--/to-exp/exp%3A%2F%2Fexp.host%2F%40sma3797%2Fsnaxa'
						to='#'
					/>
					<SingleElement
						img={riziptApp}
						className={classes.Column}
						alt='Rizipt'
						title='Rizipt (React Native App)'
						target='_blank'
						// to='https://exp.host/@sma3797/rizipt/index.exp?sdkVersion=39.0.0'
						to='#'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						img={snaxa}
						className={classes.Column}
						alt='Snaxa'
						title='Snaxa (MERN App)'
						target='_blank'
						// to='https://snaxa.com/'
						to='#'
					/>
					<SingleElement
						img={theseventales}
						className={classes.Column}
						alt='The Seven Tales'
						title='The Seven Tales'
						target='_blank'
						to='https://theseventales.com/'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						img={marlesdigitalagency}
						className={classes.Column}
						alt='Marles Digital Agency'
						title='Marles Digital Agency'
						target='_blank'
						to='http://marlesdigitalagency.com/'
					/>
					<SingleElement
						img={thetechcreators}
						className={classes.Column}
						alt='The Tech Creators'
						title='The Tech Creators'
						target='_blank'
						to='http://thetechcreators.com/'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						img={npssurvey}
						className={classes.Column}
						alt='Sheikh Muzammil Ahmed - NPS Survey'
						title='NPS Survey - Maven Marketing'
						target='_blank'
						to='https://sma3797.github.io/projects/nps-survey/index.html'
					/>
					<SingleElement
						img={nagconcept}
						className={classes.Column}
						alt='Nagreen Concepts'
						title='Nagreen Concepts'
						target
						to='https://nagreenconcepts.co.uk/'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						img={fastcashhomes}
						className={classes.Column}
						alt='Fast Cash Homes'
						title='Fast Cash Homes'
						target
						to='http://www.fastcashhomes.biz/'
					/>
					<SingleElement
						img={worldscitech}
						className={classes.Column}
						alt='World Science Tech'
						title='World Science Tech'
						target='_blank'
						to='http://worldsciencetech.com/'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						img={nonfig}
						className={classes.Column}
						alt='Sheikh Muzammil Ahmed - Nonnfig'
						title='Drip Email Integration - Nonfig'
						target='_blank'
						to='https://nonfig.com'
					/>
					<SingleElement
						img={goaplha}
						className={classes.Column}
						alt='Sheikh Muzammil Ahmed - Go Alpha Tec'
						title='Go Alpha Tec'
						target='_blank'
						to='https://staging.goalphatec.com/cloud-services/'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						className={classes.Column}
						img={deven}
						alt='Sheikh Muzammil Ahmed - Devenvision'
						title='Layouting - Devenvision'
						target='_blank'
						to='https://devenvision.com'
					/>
					<SingleElement
						img={theregaltraders}
						className={classes.Column}
						alt='Regal Traders'
						title='Regal Traders'
						to=''
					/>
				</div>

				<div className={classes.SectionHeading}>
					<h4>
						<span>MY COURSE RELATED PROJECTS</span>
					</h4>
				</div>

				<div className={classes.Row}>
					<SingleElement
						img={myplaces}
						className={classes.Column}
						alt='Sheikh Muzammil Ahmed - MERN Practice App'
						title='MERN Practice App'
						target='_blank'
						to='https://placesapp-mern.web.app/'
					/>
					<SingleElement
						img={burger}
						className={classes.Column}
						alt='Sheikh Muzammil Ahmed - Burger Builder'
						title='Burger Builder'
						target='_blank'
						to='https://react-burger-builder-f5f80.web.app/'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						img={shopify}
						className={classes.Column}
						alt='Sheikh Muzammil Ahmed - My Cart Solutions'
						title='My Cart Solutions'
						target='_blank'
						to='https://shopify-udemy-course.herokuapp.com/'
					/>
				</div>

				<div className={classes.SectionHeading}>
					<h4>
						<span>SOME PRACTICE WORK</span>
					</h4>
				</div>

				<div className={classes.Row}>
					<SingleElement
						className={classes.Column}
						img={bloggerIO}
						alt='Sheikh Muzammil Ahmed - Blogger Webstie'
						title='Blogger Webstie - Practice'
						target='_blank'
						to='https://sma3797.github.io/projects/bloggerIO/index.htm'
					/>
					<SingleElement
						className={classes.Column}
						img={hangman}
						alt='Sheikh Muzammil Ahmed - Hangman Basic'
						title='Hangman'
						target='_blank'
						to='https://sma3797.github.io/projects/hangmanBasic/index.htm	'
					/>
				</div>
				<div className={classes.Row}>
					<SingleElement
						className={classes.Column}
						img={iodesign}
						alt='Sheikh Muzammil Ahmed - IO Vibes Basic'
						title='Template'
						target='_blank'
						to='https://sma3797.github.io/projects/webIO/index.htm'
					/>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Home;
